import { StatusCodes } from "http-status-codes";
import { CLAIM_LIST, DASHBOARD_CLAIM_APIS } from "../utils/constants";
import { IClaimDownload, IClaimFilter } from "../interfaces/IClaim";
import Axios from "../utils/axiosInterceptor";

export const fetchClaimData = async (
  filters: IClaimFilter,
  pageNumber: number,
  pageSize: number
) => {
  try {
    const response = await Axios.post(
      `${CLAIM_LIST.CLAIM_lIST_DOWNLOAD}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      filters,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === StatusCodes.OK) {
      return response.data;
    } else {
      return {
        errorMessage: "Cannot fetch Claim details",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error fetching Claim details:", error);
    throw new Error("Cannot fetch Claim details");
  }
};
export const fetchClaimDownloadData = async (body: IClaimDownload) => {
  try {
    const response = await Axios.post(CLAIM_LIST.CLAIM_lIST_DOWNLOAD, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    return {
      errorMessage: "Cannot fetch data",
      status: StatusCodes.INTERNAL_SERVER_ERROR,
    };
  }
};
